import React, { ReactNode, FC } from "react";

import {
  Drawer as ChakraDrawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerContentProps,
  DrawerCloseButton,
  DrawerProps as ChakraDrawerProps,
} from "@chakra-ui/modal";
import { useCSSIsolationContainer } from "@UI/Contexts/CSSIsolation";

export interface DrawerProps extends ChakraDrawerProps {
  children: ReactNode;
  header?: ReactNode;
  closeButtonDisabled?: boolean;
  bodyPadding?: string;
  drawerContentContainerStyle?: DrawerContentProps;
}

export const Drawer: FC<DrawerProps> = ({
  children,
  header,
  placement,
  closeButtonDisabled,
  bodyPadding,
  drawerContentContainerStyle,
  portalProps,
  ...props
}) => {
  const isolationContainerRef = useCSSIsolationContainer();

  return (
    <ChakraDrawer
      placement={placement}
      variant={placement}
      portalProps={
        isolationContainerRef
          ? { containerRef: isolationContainerRef, ...portalProps }
          : portalProps
      }
      {...props}
    >
      <DrawerOverlay onClick={props.onClose} />
      <DrawerContent {...drawerContentContainerStyle}>
        {(!closeButtonDisabled || header) && (
          <DrawerHeader>
            {header}
            {!closeButtonDisabled && <DrawerCloseButton />}
          </DrawerHeader>
        )}
        <DrawerBody {...(bodyPadding ? { padding: bodyPadding } : { paddingX: 4 })}>{children}</DrawerBody>
      </DrawerContent>
    </ChakraDrawer>
  );
};
